import React from 'react';
import { Typography, Button, Space, Breadcrumb, Card } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './StandardPage.css';

const { Title, Text } = Typography;

interface BreadcrumbItem {
  title: string;
  href?: string;
}

interface ActionButton {
  label: string;
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  icon?: React.ReactNode;
  onClick: () => void;
  loading?: boolean;
  danger?: boolean;
}

interface StandardPageProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbItem[];
  showBackButton?: boolean;
  showIndietro?: string; // Se true mostra il pulsante indietro
  actions?: ActionButton[];
  children: React.ReactNode;
  loading?: boolean;
  className?: string;
}

const StandardPage: React.FC<StandardPageProps> = ({
  title,
  subtitle,
  breadcrumbs,
  showBackButton = false,
  showIndietro,
  actions = [],
  children,
  loading = false,
  className = '',
}) => {
  const navigate = useNavigate();

  // Converti breadcrumbs nel formato richiesto da Ant Design
 

  return (
    <div className={`standard-page ${className}`}>
      {/* Header della pagina */}
      <div className="standard-page-header">
       {/* Titolo */}
        <div className="standard-page-title-row">
          <div className="standard-page-title-section">
            {showBackButton ? (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <Button
      type="text"
      icon={<ArrowLeftOutlined />}
      onClick={() => navigate(-1)}
      className="standard-back-btn"
    />
    {showIndietro ? (
      <Text type="secondary" style={{ marginTop: 4, marginLeft:0 }}>{showIndietro}</Text>
    ) : null}
  </div>
) : null}
            <div>
              <Title level={2} className="standard-page-title">
                {title}
              </Title>
              {subtitle && (
                <Text type="secondary" className="standard-page-subtitle">
                  {subtitle}
                </Text>
              )}
            </div>
          </div>

          {/* Azioni */}
          {actions.length > 0 && (
            <Space size="middle" className="standard-page-actions">
              {actions.map((action, index) => (
                <Button
                  key={index}
                  type={action.type || 'default'}
                  icon={action.icon}
                  onClick={action.onClick}
                  loading={action.loading}
                  danger={action.danger}
                  className="standard-action-btn"
                >
                  {action.label}
                </Button>
              ))}
            </Space>
          )}
        </div>
      </div>

      {/* Contenuto principale */}
      <div className="standard-page-content">
        <Card
          className="standard-page-card"
          loading={loading}
          bordered={false}
        >
          {children}
        </Card>
      </div>
    </div>
  );
};

export default StandardPage;